// Bumped whenever the board is wiped. A refresh that started before the wipe holds
// the old board and must not write it back.
let generation = 0;
export const currentBoardGeneration = () => generation;
export const invalidateBoardRefreshes = () => {
    ++generation;
};
